<template>
  <div class="schedule-container">
    <!-- <page-top></page-top> -->
   
    <div class="content_wrap">
    <myImg
      img="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_5_1.png"
    ></myImg>
      <!-- <div class="son-page"></div> -->
      <my-tab
        :tab-list="tabList"
        @change="changeTab"
        :activeIndex="activeIndex"
        :bread-title="breadTitle"
        smallSize
      ></my-tab>
      <div class="show-wrap container">
        <introduce v-if="activeIndex==0" />
        <schedule v-if="activeIndex==1"></schedule>
        <ex-map v-if="activeIndex==3"></ex-map>
        <traffic v-if="activeIndex==2" />
        <ticket-way v-if="activeIndex==4" />
        <hotel v-if="activeIndex==5" ref="myhotel" />
        <div v-if="activeIndex==6" class="pre-reg-wrap">
          <img
            src="https://faststatic.ccnfgame.com/cos/vrshow/autoShow/pubImg.png"
            alt="pre-registration QR"
          />
          <span>请关注“广州国际汽车展”微信公众号购票。</span>
          <!-- <span>审核通过后获邀入场</span> -->
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
// import pageBottom from "@/components/pageBottom";
import pageFooter from "@/components/pageFooter";
import schedule from "./components/scedule";
import exMap from "./components/exMap";
import traffic from "./components/traffic";
import introduce from "./components/introduce";
import ticketWay from "./components/ticketWay";
import hotel from "./components/hotel";
import myTab from "@/components/myTab";
import myImg from "@/components/myImg";
export default {
  components: {
    pageTop,
    // pageBottom,
    schedule,
    exMap,
    traffic,
    introduce,
    ticketWay,
    hotel,
    myTab,
    myImg,
    pageFooter,
  },
  data() {
    return {
      activeIndex: 0,
      tabs: this.$route.query.tab,
      showHotel:false,
      breadTitle: {
        cn: this.$t("information.title"),
        en: "Information",
      },
      tabList: [
        {
          title:this.$t("information.exhibition"),
          en:"Exhibition ",
        },
        {
          title:this.$t("information.schedule"),
          en:"Schedule",
        },
        {
          title:this.$t("information.transportation"),
          en:"Transportation",
        },
        {
          title:this.$t("information.pavilion"),
          en:"Pavilion",
        },
        {
          title:this.$t("information.ticket"),
          en:"Ticket",
        },
        {
          title:this.$t("information.hotel"),
          en:"Hotel",
        },
        {
          title:this.$t("information.professionalPreReg"),
          en:this.$t("information.professionalPreReg"),
        }
      ]
    };
  },
  mounted() {
    this.changeTabs(this.tabs);
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      // console.log(to,from)
      if (to.query.tab != from.query.tab) {
        this.changeTabs(to.query.tab);
      }
    },
  },
  methods: {
    changeTab(index) {
      if(index==5){
      this.$refs.myhotel.showList()
      }
    },
    changeTabs(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="scss">
.schedule-container {
  width: 100vw;
  // height: 2000px;
  background: #221f26;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  min-height: 100vh;
  justify-content: space-between;
  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    .show-wrap {
      margin: 100px 0px;
      .pre-reg-wrap {
        max-width: 320px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #fff;
        margin:0 auto;
        span{
          color:rgb(227, 63, 25);
          margin:5px 0px;
          font-size: 16px;
        }
      }
      .pre-reg-wrap img {
        width: 100%;
        height: auto;
        border-radius: 8px;
      }
    }
  }
  .son-page {
    width: 1920px;
    height: 300px;
    background-image: url("https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_5_1.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .menu_wrap {
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    .schedule_wrap {
      height: 100px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      box-sizing: border-box;
      display: flex;
      > div {
        font-size: 20px;
        // width: 143px;
        line-height: 100px;
        text-align: center;
        color: #ccc;
        border-bottom: 2px solid transparent;
        margin-right: 30px;
      }
      .act-item {
        color: #42abff;
        border-bottom: 1px solid #42abff;
      }
    }
    .right_wrap {
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      align-items: center;
    }
  }
  // .schedule_detail {
  //   width: 1200px;
  //   // margin: 60px 0px;
  // }
  .header-row {
    background: #42abff !important;
    color: #fff;
    text-align: center !important;
  }
}
@media screen and (max-width: 1000px) {
  .schedule-container {
    .content_wrap {
      .menu_wrap {
        width: 100vw;
        height: 200px;
        justify-content: center;
        .about_wrap {
          // width: 100%;
          // height: 200px;
        }
        .right_wrap {
          display: none;
        }
      }
    }
  }
}
</style>

<style>
.schedule-container .el-breadcrumb__item .el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?aecb505e